export type LocalFunctionReference = {
  readonly __rpcPath: string;
  readonly __visibility: "public" | "internal";
};

export function rpcPath(reference: unknown): string {
  if (
    typeof reference !== "function" &&
    (typeof reference !== "object" || reference === null)
  ) {
    throw new Error("Riferimento API locale non valido");
  }
  const path = (reference as LocalFunctionReference).__rpcPath;
  if (!path || !path.includes(":")) {
    throw new Error("Percorso API locale non valido");
  }
  return path;
}
